import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../Components/layout/Layout";
import { errorPopup } from "../helpers";
import {
  FiArrowRight,
  FiLink,
  FiCamera,
  FiAward,
  FiGift,
  FiMic,
  FiStar,
} from "react-icons/fi";
import {
  MdAirplanemodeActive,
  MdWeb,
  MdArticle,
  MdLocalOffer,
  MdQrCode,
} from "react-icons/md";

import {
  FaPalette, // For Full-Color, Full-Page Listing (representing color/design)
  FaLink, // For Link to Your Website
  FaBlog, // For Custom Blog
  FaBullseye, // For Fly-Inn Find Game Participation (representing target/goal)
  FaAward, // For Fly-Inn Plaque with QR code (representing recognition/award)
  FaTicketAlt, // For First-Class Perks Pass
  FaInstagram, // For Instagram Frame
  FaVideo, // For Social Media Video Feature
  FaStar, // For Featured Business Spotlight
  FaMicrophoneAlt, // For Podcast Interview
  FaGift, // For $50 / $100 in Fly-Inn Service Fee Credits
} from "react-icons/fa"; // Importing necessary React Icons
const Advertise = () => {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const handleClick = () => {
    if (token) {
      // console.log(token, "token");
      navigate("/addBusiness");
      window.scrollTo({ top: 0 });
    } else {
      errorPopup("", "You must log in before you can add a business.");
    }
  };
  return (
    <>
      <Layout>
        <div className="container px-4 mx-auto md:px-20">
          <div className="mt-20 grid md:grid-cols-12 grid-cols-1 min-h-[300px]">
            <div className="md:col-span-6">
              <div className="fl-wrap">
                <h2 className="host-header">Reach All Pilots</h2>
                <h4 className="host-sub-title">
                  Help your target audience find exactly what they need, when
                  they need it.
                </h4>

                <button
                  className="host-btn !ml-0"
                  onClick={() => handleClick()}
                  style={{}}
                >
                  List Your Business
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="container px-4 mx-auto md:px-0">
          {/* Key Benefits Section */}
          <div className="py-16 bg-white">
            <div className="container px-4 mx-auto max-w-6xl">
              <div className="container  px-0 mx-auto md:px-20 !pt-0 pb-20">
                {" "}
                {/* Added container and padding for overall section */}
                <h2 className="text-4xl font-bold text-center !mb-2 text-gray-800">
                  Everything your aviation business needs to take off…
                </h2>
                <img
                  src="/image/advertise_flyer.png"
                  className="w-full  my-8"
                  alt="Advertise Flyer"
                />
                <div
                  className="my-10"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#FFFF",
                  }}
                >
                  <button
                    type="submit"
                    className="fontquick"
                    style={{
                      fontFamily: '"Quicksand", sans-serif',
                      cursor: "pointer",
                      padding: "15px",
                      borderRadius: "6px",
                      display: "flex",
                      fontSize: "16px",
                      lineHeight: "16px",
                      marginTop: "19px",
                      fontWeight: "400",
                      paddingLeft: "35px",
                      paddingRight: "35px",
                      backgroundColor: "#AF2322",
                      outline: "none",
                      color: "white",
                    }}
                    onClick={() => handleClick()}
                  >
                    List Your Business
                  </button>
                </div>
                <div className="grid gap-8 md:grid-cols-3">
                  {/* Digital Presence Card */}
                  <div className="bg-white p-6  border-solid rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100">
                    <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                      <MdWeb className="mr-3 text-blue-500 text-3xl" />{" "}
                      High-Visibility Marketing Across Multiple Channels
                    </h3>
                    <p className="text-gray-600 !p-0">All packages include:</p>
                    <ul className="list-disc  text-gray-600 mt-2 !pl-0">
                      <li>A full-color listing</li>
                      <li>A link to your website</li>
                      <li>Instagram promotion</li>
                      <li>A blog post just about your business</li>
                    </ul>
                    <p className="text-gray-600 mt-4">
                      ➡️ This multiplatform exposure boosts SEO and visibility
                      in the aviation community.
                    </p>
                  </div>

                  {/* Direct Engagement Card */}
                  <div className="bg-white p-6  border-solid rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100">
                    <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                      <MdAirplanemodeActive className="mr-3 text-green-500 text-3xl" />{" "}
                      Direct Engagement with the Pilot Community
                    </h3>
                    <p className="text-gray-600 !p-0">Features like:</p>
                    <ul className="list-disc  text-gray-600 mt-2 !pl-0">
                      <li>Participation in the Fly-Inn Find game</li>
                      <li>
                        First-Class Perks Pass (attracts pilot customers with
                        deals)
                      </li>
                      <li>
                        Plaque + Instagram frame for photo-sharing at the
                        business
                      </li>
                    </ul>
                    <p className="text-gray-600 mt-4">
                      ➡️ These turn your location into a destination for pilot
                      visitors, creating real engagement.
                    </p>
                  </div>

                  {/* Media Spotlight Opportunities Card */}
                  <div className="bg-white p-6  border-solid rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100">
                    <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                      <FiMic className="mr-3 text-purple-500 text-3xl" /> Media
                      Spotlight Opportunities (Gold & Platinum)
                    </h3>
                    <p className="text-gray-600 !p-0">
                      Video promotion (15–30 seconds) on Fly-Inn’s social
                      accounts
                    </p>
                    <ul className="list-disc  text-gray-600 mt-2 !pl-0">
                      <li>Podcast/interview</li>
                      <li>
                        Free 30-day featured business spotlight (Platinum only)
                      </li>
                    </ul>
                    <p className="text-gray-600 mt-4">
                      ➡️ These showcase your brand and story to a passionate
                      flying audience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid bg-[#FFFF] pt-0 pb-28 md:px-20">
            <h1 className="mb-5 text-3xl font-bold leading-10 text-center">
              More Than Just a Listing – Here’s What You Really Get
            </h1>
            <p className="">
              When you advertise with Fly-Inn, you’re not just buying a listing
              — you’re joining a movement. We’re connecting passionate pilots
              with aviation-friendly businesses like yours across the country.
              Here’s a breakdown of everything you get with your Silver, Gold,
              or Platinum package — and how each piece helps you attract more
              customers from the skies.
            </p>
            <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
              {/* Full-Color, Full-Page Listing */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaPalette
                    className="text-4xl mb-4 text-blue-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    Full-Color, Full-Page Listing
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">Stand out at first glance.</b>
                    Your business will be featured in vibrant, eye-catching
                    color — not a plain text link. This helps you grab attention
                    instantly and makes your listing look more premium and
                    trustworthy.
                  </p>
                </div>
              </div>

              {/* Link to Your Website */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaLink
                    className="text-4xl mb-4 text-green-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    🔗 Link to Your Website
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1"> Send traffic straight to your door.</b>{" "}
                    We connect your listing to your website so pilots can
                    explore your offerings, buy products and services, or learn
                    more with just one click.
                  </p>
                </div>
              </div>

              {/* Custom Blog */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaBlog
                    className="text-4xl mb-4 text-purple-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    📝 Custom Blog
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">Tell your story, boost your SEO.</b>
                    We write a full blog post all about your business and
                    publish it on our site — with links back to you. Great for
                    SEO, credibility, and giving people a reason to visit.
                  </p>
                </div>
              </div>

              {/* Fly-Inn Find Game Participation */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaBullseye
                    className="text-4xl mb-4 text-red-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    🎯 Fly-Inn Find Game Participation
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">Turn traffic into treasure.</b>
                    We feature your business in our exclusive “Fly-Inn Find”
                    pilot challenge — a fun scavenger hunt that encourages
                    pilots to visit listed locations. It’s a powerful way to
                    drive foot traffic and keep you top of mind.
                  </p>
                </div>
              </div>

              {/* Fly-Inn Plaque with QR code */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaAward
                    className="text-4xl mb-4 text-yellow-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    🛫 Fly-Inn Plaque with QR code
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">Earn Reviews!</b>
                    You'll receive a high-quality plaque that shows visitors
                    you’re an official Fly-Inn location. It signals to pilots
                    that your business is aviation-welcoming — and worth landing
                    for. Show you're official — and earn glowing reviews. You’ll
                    receive a high-quality plaque that shows visitors you’re an
                    official Fly-Inn location. It features a QR code that
                    visitors can scan to leave a review directly on Fly-Inn. It
                    builds trust with new guests and helps you climb the ranks
                    in our community.
                  </p>
                </div>
              </div>

              {/* First-Class Perks Pass */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaTicketAlt
                    className="text-4xl mb-4 text-orange-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    🎟️ First-Class Perks Pass
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">Offer deals pilots can’t resist.</b>
                    Feature your discount or promotion for pilots to redeem with
                    our exclusive pilot First-Class Perks Pass. Change your
                    offer at any time, directly from your dashboard. It’s a
                    simple way to boost visits and bookings.
                  </p>
                </div>
              </div>

              {/* Instagram Frame */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaInstagram
                    className="text-4xl mb-4 text-pink-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    📸 Instagram Frame
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">Make your business Insta-famous.</b>
                    We email you a stylish, Instagram-themed photo frame so
                    guests can snap pics at your location and tag Fly-Inn. It
                    turns your visitors into your promoters, creating shareable
                    content that builds your visibility on all our platforms.
                  </p>
                </div>
              </div>

              {/* Social Media Video Feature */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaVideo
                    className="text-4xl mb-4 text-teal-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    🎬 Social Media Video Feature (Gold = 15 sec, Platinum = 30
                    sec)
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">Put your business in the spotlight.</b>
                    We create a fun, polished video showcasing your business and
                    publish it across our social channels. Perfect for reaching
                    new audiences and standing out online.
                  </p>
                </div>
              </div>

              {/* Featured Business Spotlight (Platinum) */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaStar
                    className="text-4xl mb-4 text-indigo-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    🌟 Featured Business Spotlight (Platinum)
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">Enjoy premium front-row exposure.</b>
                    You’ll be listed as a featured business on our site for
                    seven days, providing you with extra visibility and a boost
                    in bookings.
                  </p>
                </div>
              </div>

              {/* Podcast Interview (Platinum) */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaMicrophoneAlt
                    className="text-4xl mb-4 text-gray-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    🎙️ Podcast Interview (Platinum)
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">Share your story on air.</b>
                    Get interviewed on the Fly-Inn Frequency podcast — a unique
                    opportunity to tell your business story to a whole world of
                    aviation lovers and future customers.
                  </p>
                </div>
              </div>

              {/* $50 / $100 in Fly-Inn Service Fee Credits (Gold / Platinum) */}
              <div>
                <div style={{ marginLeft: "21px" }}>
                  <FaGift
                    className="text-4xl mb-4 text-lime-600"
                    style={{ display: "flex", justifyContent: "center" }}
                  />
                  <h1
                    style={{
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontWeight: "700",
                      textAlign: "start",
                      marginTop: "20px",
                    }}
                  >
                    🎁 $50 to $100 in Fly-Inn Service Fee Credits (Gold /
                    Platinum)
                  </h1>
                  <p
                    style={{
                      fontWeight: "400",
                      marginTop: "13px",
                      fontFamily: "Quicksand",
                    }}
                  >
                    <b className="mr-1">
                      Platform perks that pay for themselves.
                    </b>
                    As a Gold or Platinum advertiser, you’ll receive $50 in
                    Fly-Inn credit to use toward service fees on short-term
                    rental bookings. Use it for your own getaways — or gift it
                    to friends, clients, or team members. Either way, it's real
                    value back in your pocket. And when you use it, if you film
                    your stay and share the video with us to post on social
                    media, we will give you another $50 service fee credit!
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            className="p-20"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "50px",
              backgroundColor: "#FFFF",
            }}
          >
            <h1 style={{ fontWeight: "700", fontSize: "36px" }}>
              List Your Business!
            </h1>

            <h6
              style={{
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "300",
                lineHeight: "30px",
                marginTop: "14px",
              }}
            >
              Get listed. Get noticed. Get more pilots through your door. Start
              advertising with Fly-Inn today
            </h6>
            <Link to={"/addBusiness"}>
              <button
                type="submit"
                className="fontquick"
                style={{
                  fontFamily: '"Quicksand", sans-serif',
                  cursor: "pointer",
                  padding: "15px",
                  borderRadius: "6px",
                  display: "flex",
                  fontSize: "16px",
                  lineHeight: "16px",
                  marginTop: "19px",
                  fontWeight: "400",
                  paddingLeft: "35px",
                  paddingRight: "35px",
                  backgroundColor: "#AF2322",
                  outline: "none",
                  color: "white",
                }}
              >
                List Your Business
              </button>
            </Link>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Advertise;
